<template>
  <div>
    <label v-if="label" class="block mb-2 text-sm" :for="name">{{
      label
    }}</label>
    <!-- <DatePicker
      v-model="model"
      :locale="fi"
      :style="style"
      input-format="dd.MM.yyyy"
      class="w-full px-2 py-1 text-lg border border-gray-200"
    /> -->
    <VueDatePicker
      v-model="model"
      :format-locale="fi"
      :transitions="false"
      hide-input-icon
      :format="format"
      :style="style"
      position="left"
      :enable-time-picker="false"
      auto-apply
      :action-row="{ showNow: true, showPreview: false, showCancel: false, showSelect: false }"
      class="w-full px-2 py-1 text-lg border border-gray-200"
    />
    <Field
      class="hidden"
      type="text"
      v-model="model"
      :id="name"
      :name="name"
      :rules="rules"
    />
    <ErrorMessage class="mt-2 text-xs text-red-500" :name="name" />
  </div>
</template>

<script>
// import DatePicker from "vue3-datepicker";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { Field, ErrorMessage } from "vee-validate";
import { fi } from "date-fns/locale";
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "DateInput",
  components: { VueDatePicker, Field, ErrorMessage },
  props: {
    name: {
      required: true,
      type: String,
    },
    label: {
      required: false,
      default: () => null,
      type: String,
    },
    rules: {
      required: false,
      default: () => null,
      type: Function,
    },
  },
  setup({ name }) {
    const store = useStore();

    const model = computed({
      get() {
        const value = store.getters.resolve(name);

        if (value === null) {
          return null;
        }

        return new Date(value);
      },
      set(value) {
        store.commit("set", { name, value: value !== "" ? value : null });
      },
    });

    const format = (date) => {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    };

    return {
      model,
      fi,
      format,
      style: {
        // "--vdp-hover-bg-color": "rgb(0, 72, 132)",
        // "--vdp-selected-bg-color": "rgb(0, 72, 132)",
        "--dp-highlight-color": "rgba(0, 92, 178, 0.2)",
        "--dp-border-radius": "0px",
        "--dp-hover-color": "#004884",
        "--dp-border-color-hover" : "#004884",
        "--dp-hover-text-color": "rgb(0, 72, 132)",
        "--dp-hover-icon-color": "rgb(0, 72, 132)",
        "--dp-cell-border-radius": "0px",
        "--dp-primary-color": "#004884",
      },
    };
  },
};
</script>
